<template>
  <main id="vendors-list" class="site-main">
    <div class="grid-container">
      <div class="single-detail">
        <div class="single-detail__header">
          <div class="grid-x align-bottom">
            <div class="cell shrink">
              <h1 style="font-size: 30px; margin: 0 15px 0 0;">Invoice #{{ data.invoice_number }}</h1>
            </div>

            <div class="cell shrink">
              {{ data.created_date }}
            </div>

            <div class="cell auto text-right">
              <div style="font-size: 24px; font-weight: 700;">
                {{ data.amount }}
              </div>
            </div>
          </div>

          <div class="text-right" style="padding-top: 15px;">
            <span class="icon-action" @click="exportPayout">
              <i class="far fa-arrow-to-bottom"></i> <span>Export</span>
            </span>
          </div>

          <div style="padding-top: 15px;">
            <button @click="downloadReport">Print Invoice</button>
          </div>
        </div>
      </div>

      <div class="grid-x grid-padding-x">
        <div class="cell auto">
          <div class="panel no-padding">
            <!--            <searchBar placeholder="Search line items" @sort="sort"-->
            <!--                       :value="searchValue"-->
            <!--                       @search="search"></searchBar>-->

            <div :class="['loading-area', loading ? 'loading' : '']">
              <div :class="['loading-area__content', loading ? 'loading' : '']">
                <!--                <pagination :prev="prev" :next="next" :start="start" :end="end"-->
                <!--                            :total="total"-->
                <!--                            @paginate="paginate"></pagination>-->

                <tableList :header="tableHeader" :data="tableData"
                           :loading="loading" classes="no-hover"
                           @sort="orderBy"></tableList>

                <!--                <pagination :prev="prev" :next="next" :start="start" :end="end"-->
                <!--                            :total="total"-->
                <!--                            @paginate="paginate"></pagination>-->
              </div>
            </div>
          </div>
        </div>

        <div class="cell large-shrink">
          <div class="sidebar">
            <div class="panel">
              <div class="form-field">
                <label>Vendor</label><br>
                <div><router-link :to="'/vendors/' + data.vendor">
                  {{ data.vendor_name }}</router-link></div>
              </div>

              <hr>

              <div class="form-field">
                <label>Notes</label><br>
                <div style="margin-bottom: 20px;">{{ data.note }}</div>
                <button class="button--small" @click="updatePopup = true">
                  Edit Notes</button>
              </div>
            </div>

            <button class="button--red" @click="deletePayout">Delete Payout</button>
          </div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div class="overlay" v-if="updatePopup">
        <div class="overlay__inner">
          <div class="panel">
            <div class="panel__header">
              <h3 class="panel__title">Update Payout Note</h3>

              <span class="overlay__close" @click="closeUpdatePopup">
                <i class="fal fa-times"></i></span>
            </div>

            <div class="panel__content">
              <form>
                <div class="form-field">
                  <div class="grid-x grid-padding-x">
                    <div class="cell small-4">
                      <label for="payout-note">Note</label>
                    </div>

                    <div class="cell auto">
                      <textarea id="payout-note"
                                name="note"
                                rows="6"
                                :value="data.note"></textarea>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div class="panel__footer text-right">
              <button class="button--alt" @click="closeUpdatePopup">Cancel
              </button>

              <button @click="updatePayout()">Save</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </main>
</template>

<script>
import client from '@/mixins/client'
import paginationUtils from '@/mixins/paginationUtils'
import axios from 'axios'
import {API_ROOT_URL} from '@/localSettings'

import moment from 'moment'

export default {
  name: 'ordersList',
  mixins: [client, paginationUtils],
  data: function () {
    return {
      action: '/vendors/payouts/' + this.$route.params.id + '/?expand=line_items_w_order',
      sort: '-created_date',
      loading: true,
      tableHeader: {
        currentSort: '-created_date',
        data: [
          {
            label: 'Order',
            class: 'small'
          },
          {
            label: 'Product',
            class: 'full'
          },
          // {
          //   label: 'Customer',
          //   class: 'medium show-for-xlarge'
          // },
          // {
          //   label: 'Fulfillment',
          //   class: 'medium'
          // },
          {
            label: 'Price'
          },
          {
            label: 'Commission'
          },
          {
            label: 'Date',
            class: 'large'
          }
        ]
      },
      tableData: [],
      updatePopup: false,
      updatePopupLoading: false
    }
  },
  methods: {
    closeUpdatePopup () {
      this.updatePopup = false
    },
    updatePayout () {
      this.updatePopupLoading = true
      let note = document.getElementById('payout-note').value
      this.request('put', '/vendors/payouts/' + this.$route.params.id + '/update/', {
        note: note
      }).then((response) => {
        this.data.note = note
        this.updatePopup = false
        this.updatePopupLoading = false
      })
    },
    exportPayout () {
      this.request('get', '/vendors/payouts/' + this.$route.params.id + '/csv/', {
        ordering: '-created_date',
        page_size: 1000,
        format: 'csv'
      }).then((response) => {
        let downloadLink = document.createElement('a')

        downloadLink.href = response
        downloadLink.target = '_blank'

        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)

        this.loading = false
      })
    },
    deletePayout () {
      this.request('delete', '/vendors/payouts/' + this.$route.params.id + '/delete/').then(response => {
        this.$router.push('/payouts/')
      })
    },
    downloadReport () {
      axios({
        method: 'post',
        url: API_ROOT_URL + '/vendors/export-payout/?id=' + this.data.id
      }).then((response) => {
        if (response.status === 200) {
          let link = document.createElement('a')
          link.download = 'payout.pdf'
          link.href = response.data
          link.target = '_blank'
          link.textContent = 'Download payouts.csv'

          link.click()
        }
      })
    },
    buildTable () {
      this.data.amount = this.formatMoney(this.data.amount)

      let lineItems = this.data.line_items
      this.data.created_date = moment(this.data.created_date).format('MMM D, YYYY [at] h:mma')

      for (let i = 0; i < lineItems.length; i++) {
        let lineItem = lineItems[i].line_item

        lineItem.date = moment(lineItem.order.processed_at).format('MMM D, YYYY [at] h:mma')
        lineItem.financial_status = 'paid'
        lineItem.financialLabel = 'success'
        lineItem.customer_name = 'N/A'

        this.price = this.formatMoney(this.data.price)

        lineItem.fulfillmentStatus = lineItem.fulfillment_status

        if (lineItem.fulfillment_status === 'partial') {
          lineItem.fulfillmentLabel = 'warning'
          lineItem.fulfillmentStatus = 'Partially Fulfilled'
        } else if (lineItem.fulfillment_status === 'restocked' ||
          lineItem.fulfillment_status === null) {
          lineItem.fulfillmentLabel = 'alert'
        } else {
          lineItem.fulfillmentLabel = 'success'
        }

        if (lineItem.fulfillment_status === null) {
          lineItem.fulfillmentStatus = 'Unfulfilled'

          lineItem.fulfillmentStatus = this.formatText(lineItem.fulfillmentStatus)
        }

        let primary = '<div class="grid-x align-middle"><div class="cell shrink">' +
          '<div class="table-list__image">'

        if (lineItem.variant && !this.isEmpty(lineItem.variant.image) && lineItem.variant.image !== undefined && lineItem.variant.image.src !== undefined) {
          primary += '<div class="table-list__image__inner">'
          primary += '<img src="' + lineItem.variant.image.src + '">'
          primary += '</div>'
        } else if (!this.isEmpty(lineItem.image) && lineItem.image !== undefined) {
          primary += '<div class="table-list__image__inner">'
          primary += '<img src="' + lineItem.image + '">'
          primary += '</div>'
        } else {
          primary += '<div class="table-list__image__missing"><i class="fas fa-image"></i></div>'
        }

        if (lineItem.variant !== null) {
          if (lineItem.variant.product !== null) {
            primary += '</div></div><div class="cell auto" style="overflow: hidden; text-overflow: ellipsis;"><span style="white-space: nowrap;">' + lineItem.variant.product.title + '</span>'
          } else {
            primary += '</div></div><div class="cell auto">'
          }

          if (lineItem.variant !== null && lineItem.variant.title !== null && lineItem.variant.title.length > 0 && lineItem.variant.title !== 'Default Title') {
            primary += '<br><span class="text-overflow"><small><i>' + lineItem.variant.title + '</i></small></span>'
          }
        } else {
          primary += '</div></div><div class="cell auto">'

          if (lineItem.title !== null && lineItem.title.length > 0) {
            primary += '<span class="text-overflow">' + lineItem.title + '</span>'
          } else {
            primary += '<span class="text-overflow">' + lineItem.name + '</span>'
          }
        }

        if (lineItem.sku !== null && lineItem.sku.length > 0) {
          primary += '<br><span class="text-overflow"><small><i>' + lineItem.sku + '</i></small></span>'
        }

        primary += '</div></div>'

        let price = '<div class="grid-x align-middle"><div class="cell shrink">' + this.formatMoney(lineItem.price)

        if (lineItem.allocated_discount > 0) {
          price += '<div class="text-right">-' + this.formatMoney(lineItem.allocated_discount) + '</div>'
        }

        price += '</div><div class="cell auto text-right" style="white-space: nowrap;">x ' + lineItem.quantity + '</div></div>'

        let commission = this.formatMoney(lineItems[i].amount)

        if (lineItems[i].commission_type === 'override') {
          commission = '*' + commission
        }

        this.tableData.push({
          data: [
            {
              value: lineItem.order.name,
              link: '/orders/' + lineItem.order.id,
              class: 'small'
            },
            {
              value: primary,
              class: 'full'
            },
            // {
            //   value: lineItem.customer_name,
            //   class: 'medium show-for-xlarge'
            // },
            // {
            //   value: this.formatText(lineItem.fulfillment_status),
            //   class: 'medium',
            //   span: 'label ' + lineItemFulfillmentStatus
            // },
            {
              value: price,
              span: 'fill'
            },
            {
              value: commission,
              span: 'focus-text'
            },
            {
              value: lineItem.date,
              class: 'large'
            }
          ]
        })

        this.loading = false
      }
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/mixins';

</style>



// WEBPACK FOOTER //
// src/pages/payouts/single.vue